import React from "react";

const ErrorLogin = () => <div>Error Message</div>;

export default ErrorLogin;
